import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  return (
    <div className="navbar">
      <div className="logo">Fire Tracker</div>

      <div className="nav-links">
        <Link to="/" className={location.pathname === "/" ? "active-link" : ""}>
          Dashboard
        </Link>
        <Link to="/report">Report Incident</Link>
        <Link to="/logout">Sign Out</Link>
      </div>
    </div>
  );
};

export default Navbar;
